import { render, staticRenderFns } from "./TipEncouragementView.vue?vue&type=template&id=5447aef6&scoped=true"
import script from "./TipEncouragementView.vue?vue&type=script&lang=js"
export * from "./TipEncouragementView.vue?vue&type=script&lang=js"
import style0 from "./TipEncouragementView.vue?vue&type=style&index=0&id=5447aef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5447aef6",
  null
  
)

export default component.exports